import { useCallback, useState, useEffect } from 'react';
import { useSetJobStatus } from 'src/hooks/job';
import { JOB_ERSA_GENERATION_STATUS_QUERY } from 'src/graphql/job/query';
import client from 'src/utils/api/client';
import { useTranslation } from 'react-i18next';
import { notification } from 'src/components/Notification';

export default reloadJob => {
  const { t } = useTranslation();

  const [pollErsaGenerationStatusForJob, setPollErsaGenerationStatusForJob] = useState();

  useEffect(() => {
    if (pollErsaGenerationStatusForJob) {
      let timeout = null;

      const reloadErsaGenerationStatus = async () => {
        try {
          const result = await client.query({
            query: JOB_ERSA_GENERATION_STATUS_QUERY,
            variables: {
              id: pollErsaGenerationStatusForJob,
            },
            fetchPolicy: 'no-cache'
          });

          const { ersaGenerationStatus } = result?.data?.job || {};

          if (ersaGenerationStatus === 'success') {
            setPollErsaGenerationStatusForJob(null);
            
            return;
          }
          if (ersaGenerationStatus === 'fail') {
            setPollErsaGenerationStatusForJob(null);
            
            notification.info(t('ERSA_GENERATION_FAILED_MESSAGE'), {
              autoClose: 30000,
            });
            return;
          }
          // eslint-disable-next-line no-empty
        } catch (e) {}

        timeout = setTimeout(reloadErsaGenerationStatus, 1000);
      };
      timeout = setTimeout(reloadErsaGenerationStatus, 1000);

      return () => clearTimeout(timeout);
    }

    return () => {};
  }, [pollErsaGenerationStatusForJob]);

  const setJobStatus = useSetJobStatus();

  return useCallback(async values => {
    const { redirect, ...rest } = values;
    await setJobStatus(rest);
    if (redirect) return;
    if (['finish_review', 'finish_internal_saq'].includes(values?.event)) {
      setPollErsaGenerationStatusForJob(values?.jobId);
    }
    reloadJob();
  }, []);
};
